import React from 'react'
import { DarkContainer, GradientDivider } from '../styles/containers'
import { Box, Typography } from '@mui/material'
import { FooterLink, HightlightedLink, SocialLink, SocialLinkContent } from '../styles/links'
import { highlight } from '../styles/colors'
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import LangSelector from '../lang/LangSelector'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { useTranslation } from 'react-i18next'
import { termsAndConditionsRoute, usePathReconstructor } from '../config/pageRoutes'

type Props = {}

const Footer = (props: Props) => {
    const { t } = useTranslation();
    const { copyParamsFromPath } = usePathReconstructor()
    return (
        <Box pt={3}>
            <div className="px-6 pb-2 max-w-[1600px] mx-auto">
                <DarkContainer>
                    <div className="py-4 px-8">
                        <div className="flex gap-2 flex-col md:flex-row">
                            <div className="md:text-left text-center">
                                <div className="flex justify-center md:justify-start" >
                                    <img
                                        src={process.env.REACT_APP_PUBLIC_URL + '/assets/logo_white.svg'}
                                        width={"70px"}
                                    />
                                </div>
                                <Box pt={3}>
                                    <Typography color="white" fontSize="16px" fontFamily="Avenir Next">
                                        Email: <HightlightedLink href="mailto:info@reservours.com">
                                            info@reservours.com
                                        </HightlightedLink>
                                    </Typography>
                                    <Typography color="white" fontSize="16px" fontFamily="Avenir Next" pt={1}>
                                        {t("common.phone")}: <span style={{ color: highlight.deep }}>
                                            info@reservours.com
                                        </span>
                                    </Typography>
                                </Box>
                            </div>
                            <div className="grow">
                                <div className="mt-3 md:mt-[50px]" />
                                <div className="text-center md:hidden">
                                    <Typography fontSize={"16px"} color="white" fontFamily="Avenir Next" fontWeight={"bold"} mb={2} >
                                        {t("footer.follow_us")}
                                    </Typography>
                                </div>
                                <div className="flex flex-wrap gap-4 justify-center md:justify-end">
                                    <div className="">
                                        <div className="hidden md:block">
                                            <Typography fontSize={"16px"} color="white" fontFamily="Avenir Next" fontWeight={"bold"} mb={2} >
                                                {t("footer.follow_us")}
                                            </Typography>
                                        </div>
                                        <SocialLink href="https://www.facebook.com/reservours/" >
                                            <SocialLinkContent>
                                                <div className="h-[42px] flex items-center px-4">
                                                    <div className="flex gap-2">
                                                        <div>
                                                            <FacebookOutlinedIcon />
                                                        </div>
                                                        <div>
                                                            Facebook
                                                        </div>
                                                    </div>
                                                </div>
                                            </SocialLinkContent>
                                        </SocialLink>
                                    </div>
                                    <div>
                                        <SocialLink href="https://www.instagram.com/reservours/" >
                                            <div className="pt-0 md:pt-[40px]">
                                                <SocialLinkContent>
                                                    <div className="h-[42px] flex items-center px-4">
                                                        <div className="flex gap-2">
                                                            <div>
                                                                <InstagramIcon />
                                                            </div>
                                                            <div>
                                                                Instagram
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SocialLinkContent>
                                            </div>
                                        </SocialLink>
                                    </div>
                                    <div >
                                        <SocialLink href="https://hu.linkedin.com/company/reservours" >
                                            <div className="pt-0 md:pt-[40px]">
                                                <SocialLinkContent>
                                                    <div className="h-[42px] flex items-center px-4">
                                                        <div className="flex gap-2">
                                                            <div>
                                                                <LinkedInIcon />
                                                            </div>
                                                            <div>
                                                                LinkedIn
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SocialLinkContent>
                                            </div>
                                        </SocialLink>
                                    </div>
                                    <div className="w-full md:w-fit text-center flex items-center justify-center" >
                                        <div className="pt-0 md:pt-[40px]">
                                            <LangSelector />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Box py={4}>
                            <GradientDivider />
                        </Box>
                        <Box>
                            <div className="flex flex-col gap-6 md:flex-row" >
                                <div className="text-center md:text-left " >
                                    <Typography fontFamily={"Avenir Next"} fontSize="12px" color="#F2FEFF">
                                        {t("footer.all_rights_reserved")}
                                    </Typography>
                                </div>
                                <div className="grow" >
                                    <div className="flex flex-col md:flex-row gap-6 items-center md:justify-end">
                                        <div >
                                            <FooterLink to={copyParamsFromPath(termsAndConditionsRoute.path)}>
                                                {t("footer.terms_and_conditions")}
                                            </FooterLink>
                                        </div>
                                        <div >
                                            <FooterLink to={copyParamsFromPath(termsAndConditionsRoute.path)}>
                                                {t("footer.privacy_policy")}
                                            </FooterLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex justify-center items-center mt-6">
                                <img
                                    src={process.env.REACT_APP_PUBLIC_URL + '/assets/barion-banner-lightmode.svg'}
                                    alt="Barion banner"
                                    style={{ maxWidth: '200px', width: '100%' }}
                                />
                            </div>
                        </Box>
                    </div>
                </DarkContainer>
            </div>
        </Box>
    )
}

export default Footer